import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Button, Popup } from "semantic-ui-react";
import { ReactComponent as RowInfoSvg } from "../../../../../assets/rowInfo.svg";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { ReactComponent as PlusCircle } from "../../../../../assets/plusCircle.svg";
import { ReactComponent as BackArrowSvg } from "../../../../../assets/backarrow.svg";
import { ReactComponent as NoRecordSvg } from "../../../../../assets/norecord.svg";
import { useStore } from "../../../../../app/stores/store";
import TablePlaceholder from "../../../products/tables/TablePlaceholder";
import Loading from "../../../../../app/layout/Loading";

const AllReturnLocations = () => {
  const [active, setActive] = useState(0);
  const list = [0, 1, 2, 3, 4, 5];
  const colours = ["#32C36C", "#E53511"];
  const navigate = useNavigate();
  const [pop, setPop] = useState("active");
  const { shippingStore } = useStore();
  const {
    loadingInitial,
    getVendorReturnLocations,
    vendorReturnLocationList,
    deleteReturnLocation,
    loading,
  } = shippingStore;
  const deleteRow = async (value: string) => {
    setPop("");
    await deleteReturnLocation(value).finally(() => setPop("active"));
  };
  useEffect(() => {
    getVendorReturnLocations();
  }, []);
  return (
    <div>
      {(loadingInitial === "loading" || loading) && <Loading />}
      <div className={styles.header}>
        <div className={styles.back}>
          <BackArrowSvg onClick={() => navigate("/vendor/shipping")} />
          <span>Go back</span>
        </div>
        <div className={styles.searchAndFilter}>
          <Button
            positive
            className={styles.activate}
            onClick={() => navigate("/vendor/shipping/new-returnlocation")}
          >
            <div className={styles.positive}>
              <span>New Return Location</span>
              <PlusCircle />
            </div>
          </Button>
        </div>
      </div>
      <div className={styles.headerTitle}>Preferred Return Location</div>
      {loadingInitial === "loading" && <TablePlaceholder />}
      {!(loadingInitial === "loading" || loading) &&
      vendorReturnLocationList.length > 0 ? (
        vendorReturnLocationList.map((location, index) => {
          return (
            <div key={index} className={styles.shippingAddressWrapper}>
              <div
                className={styles.shippingAddress}
                onClick={() => setActive(index)}
              >
                <div className={styles.shippingAddressInfo}>
                  <div className={styles.name}>Address</div>
                  <div className={styles.contact}>
                    <div className={styles.mail}>{location.address}</div>
                  </div>
                </div>
                <div className={styles.shippingAddressInfo}>
                  <div className={styles.name}>City</div>
                  <div className={styles.contact}>
                    <div className={styles.mail}>{location.city}</div>
                  </div>
                </div>
                <div className={styles.shippingAddressInfo}>
                  <div className={styles.name}>State</div>
                  <div className={styles.contact}>
                    <div className={styles.mail}> {location.state}</div>
                  </div>
                </div>
                <div className={styles.infoIcon}>
                  {pop === "active" && (
                    <Popup
                      trigger={<RowInfoSvg />}
                      content={
                        <div className={styles.menu}>
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              navigate(location.returnProductLocationId)
                            }
                          >
                            Edit
                          </div>
                          <hr />
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              deleteRow(location.returnProductLocationId)
                            }
                          >
                            Delete
                          </div>
                        </div>
                      }
                      on="click"
                      position="bottom center"
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className={styles.norecord}>
          <NoRecordSvg />
        </div>
      )}
    </div>
  );
};

export default observer(AllReturnLocations);
